import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { branch, compose, renderComponent } from 'recompose'
import withSlugSelector from 'Selectors/common/withSlugSelector'
import CategoryPage from 'Components/Common/CategoryPage/CategoryPage'
import Device from 'Components/Common/Device'
import Page from 'Components/Common/Page/Page'
import NotFound from 'Components/Common/Page/NotFound'
import CloudServices from '../CloudServices'
import ServiceExtensionOverview from '../ServiceExtensions/Overview'

const mapStateToProps = (state, props) => ({
  item: withSlugSelector(props.match.params.slug)(state, props),
})

const branchComponentTypes = types =>
  compose(
    ...types.map(type =>
      branch(
        ({ item }) => item['@type'] === type.type,
        renderComponent(type.render),
      ),
    ),
  )

const enhance = compose(
  withRouter,
  connect(mapStateToProps),
  branch(({ item }) => !item, renderComponent(NotFound)),
  branchComponentTypes([
    { type: 'Device', render: Device },
    { type: 'Category', render: CategoryPage },
    { type: 'Page', render: Page },
    { type: 'CloudService', render: CloudServices },
    { type: 'ServiceExtensionOverview', render: ServiceExtensionOverview },
  ]),
)

const Slug = () => null

export default enhance(Slug)
